module.exports = __webpack_public_path__ + "img/_selected.ab8653c3.svg";